import { createORPCClient, onError, type ClientContext } from "@orpc/client";
import { RPCLink, type RPCLinkOptions } from "@orpc/client/fetch";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import type { RouterClient } from "@orpc/server";
import type { AdminRouter } from "@corpuscomplete/core/orpc";
import { Env } from "../env";

/**
 * User RPC transport config.
 *
 * Calls `/rpc` and always includes cookies so server auth/session middleware can authorize
 * requests from browser clients.
 */
export const userLinkOptions: RPCLinkOptions<ClientContext> = {
  url: `${Env.VITE_API_URL}/rpc`,
  fetch: (input, init) =>
    fetch(input, {
      ...init,
      credentials: "include",
    }),
  interceptors: [
    onError((error) => {
      console.error("RPC error:", error);
    }),
  ],
};

const adminLink = new RPCLink({
  url: `${Env.VITE_API_URL}/rpc/admin`,
  fetch: (input, init) =>
    fetch(input, {
      ...init,
      credentials: "include",
    }),
  interceptors: [
    onError((error) => {
      console.error("RPC admin error:", error);
    }),
  ],
});

const adminRpcClient = createORPCClient<RouterClient<AdminRouter>>(adminLink);

/**
 * Admin RPC query/mutation utilities.
 *
 * Surface:
 * - Targets `/rpc/admin` only.
 * - Typed from the admin router contract in core.
 */
export const adminRpc = createTanstackQueryUtils(adminRpcClient, { path: ["adminRpc"] });
